import { render } from "./keyword.vue?vue&type=template&id=d938009c&scoped=true&ts=true"
import script from "./keyword.vue?vue&type=script&lang=ts"
export * from "./keyword.vue?vue&type=script&lang=ts"

import "./keyword.vue?vue&type=style&index=0&id=d938009c&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d938009c"]])

export default __exports__